import store from "../store"
import { Emitter, Raf } from "../core"

export default class Scrollbar {
  constructor() {
    this.el = null
    this.handle = null
    this.touching = false
    this.state = {
      clicked: false,
      scale: 0,
      current: 0,
    }
    this.height = 0
    this.init()
  }

  init() {
    this.create()
    this.setBounds()
    this.on()
  }

  on() {
    Emitter.on("tick", this.transform)
    Emitter.on("resize", this.resize)
    this.handle.addEventListener("mousedown", this.mouseDown)
    window.addEventListener("mouseup", this.mouseUp)
    window.addEventListener("mousemove", this.mouseMove)
  }

  off() {
    Emitter.off("tick", this.transform)
    Emitter.off("resize", this.resize)
  }

  mouseDown = () => {
    this.touching = true

    document.body.style.userSelect = "none"
    document.body.style.webkitUserSelect = "none"
    document.body.style.pointerEvents = "none"
    // document.documentElement.style.userSelect = "none"
    // document.documentElement.style.pointerEvents = "none"
  }

  mouseUp = () => {
    this.touching = false

    document.body.style.userSelect = "inherit"
    document.body.style.webkitUserSelect = "inherit"
    document.body.style.pointerEvents = "inherit"
    // document.documentElement.style.userSelect = "inherit"
    // document.documentElement.style.pointerEvents = "inherit"
  }

  mouseMove = e => {
    if (this.touching === true) {
      const { isLocked } = store.flags

      if (isLocked) return

      store.raf.scroll.target = e.clientY * this.state.scale
      store.raf.clamp()
    }
  }

  setBounds() {
    const { vh, fh } = store.page
    const scrollLimit = fh
    this.state.scale = (scrollLimit + vh) / vh
    this.handle.style.height = `${vh / this.state.scale}px`
  }

  transform = ({ current }) => {
    const scroll = current / this.state.scale
    this.state.current = scroll
    this.handle.style.transform = `translate3d(0, ${this.state.current}px, 0)`
  }

  resize = () => {
    this.setBounds()
  }

  calcScroll(e) {
    const delta = e.clientY * this.state.scale
    Raf.target = delta
    Raf.clampTarget()
  }

  create() {
    this.el = document.createElement("div")
    this.handle = document.createElement("div")
    this.el.classList.add("-scrollbar", "js-scrollbar")
    this.handle.classList.add("-handle", "js-handle")

    Object.assign(this.el.style, {
      position: "fixed",
      top: 0,
      right: 0,
      height: "100%",
      pointerEvents: "all",
    })

    Object.assign(this.handle.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      cursor: "pointer",
      zIndex: 101,
    })

    store.currentPage.appendChild(this.el)
    this.el.appendChild(this.handle)
  }

  update() {
    this.setBounds()
  }

  destroy() {
    this.off()
  }
}
